import { render, staticRenderFns } from "./HelpArticlesComponent.vue?vue&type=template&id=37139332&scoped=true&"
import script from "./HelpArticlesComponent.vue?vue&type=script&lang=js&"
export * from "./HelpArticlesComponent.vue?vue&type=script&lang=js&"
import style0 from "./HelpArticlesComponent.vue?vue&type=style&index=0&id=37139332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37139332",
  null
  
)

export default component.exports